import React from 'react';

const LegacyPlanRecommendation = () => (
     <p className="text-center recommendation-text">
          You are currently on a legacy plan. Our new plans provide more features and flexibility. Compare them to upgrade.
     </p>
)

export default LegacyPlanRecommendation;